// Angular
import { Component, HostBinding, OnInit, Input } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
// RxJS
import { filter } from "rxjs/operators";
import { TranslationService } from "../../../service/translation.service";
// Translate

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

@Component({
    selector: "kt-language-selector",
    templateUrl: "./language-selector.component.html",
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {
  // Public properties
  @HostBinding("class") classes = "";
  @Input() iconType: "" | "brand";

  language: LanguageFlag;
  languages: LanguageFlag[] = [
    {
      lang: "en",
      name: "English",
      flag: "./assets/media/flags/012-uk.svg",
    },
    // {
    //   lang: "ch",
    //   name: "Mandarin",
    //   flag: "./assets/media/flags/015-china.svg",
    // },
    // {
    //   lang: "es",
    //   name: "Spanish",
    //   flag: "./assets/media/flags/016-spain.svg",
    // },
    // {
    //   lang: "jp",
    //   name: "Japanese",
    //   flag: "./assets/media/flags/014-japan.svg",
    // },
    // {
    //   lang: "gr",
    //   name: "German",
    //   flag: "./assets/media/flags/017-germany.svg",
    // },
    // {
    //   lang: "fr",
    //   name: "French",
    //   flag: "./assets/media/flags/019-france.svg",
    // },
  ];

  /**
   * Component constructor
   *
   * @param translationService: TranslationService
   * @param router: Router
   */
  constructor(
    private translationService: TranslationService,
    private router: Router
  ) { }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    this.setSelectedLanguage();
    this.translationService.languageChange.subscribe((lang) => {
      this.setLanguage(lang);
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.setSelectedLanguage();
      });
  }

  setLanguage(lang: string) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
  }

  setSelectedLanguage() {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }

}
